<template>
  <div class="tips" v-if="!isFloorTableAvailable.table_id">
    <h6 class="title">
      {{ _T('Tips For Driver') }}
      <span class="d-sm-none">{{ currency }} {{ driver_tip }}</span>
    </h6>
    <ul>
      <li :class="{ active: tip == '15%' }">
        <label>
          15%
          <input type="radio" v-model="tip" value="15%" />
        </label>
      </li>
      <li :class="{ active: tip == '20%' }">
        <label>
          20%
          <input type="radio" v-model="tip" value="20%" />
        </label>
      </li>
      <li :class="{ active: tip == '25%' }">
        <label>
          25%
          <input type="radio" v-model="tip" value="25%" />
        </label>
      </li>
      <li :class="{ active: !tip.toString().match('%') }">
        <label @click="$bvModal.show('customTips')">
          {{ _T('custom') }}
          <input type="radio" v-model.number="tip" />
        </label>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DriverTips',
  data() {
    return {}
  },
  computed: {
    tip: {
      get() {
        return this.$store.state.cart_store.driverTip
      },
      set(val) {
        this.$store.commit('SET_TIP', val)
      },
    },
    ...mapGetters(['_T', 'driver_tip', 'isFloorTableAvailable']),
  },
}
</script>
<style lang="scss" scoped>
.tips {
  .title {
    @media (max-width: 767px) {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      font-weight: 600;
      font-size: $px13;
      line-height: $px22;
      letter-spacing: 0.02em;
      color: $font-color;
      text-transform: capitalize;
    }
  }
  @media (max-width: 767px) {
    ul {
      display: flex;
      width: 100%;
      li {
        background: $white;
        border: $px1 solid $color-primary;
        border-radius: $px4;
        font-weight: 600;
        font-size: $px14;
        line-height: $px17;
        letter-spacing: 0.005em;
        color: $color-primary;
        width: 22%;
        height: $px36;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: capitalize;
        cursor: pointer;
        &.active {
          background-color: $color-primary;
          color: $white;
        }
        + li {
          margin-left: $px10 !important;
        }
      }
    }
  }
  label {
    cursor: pointer;
    display: grid;
    @media (max-width: 767px) {
      display: flex;
      // margin-left: 7%;
    }
    margin: 0;
    padding: 0;
    input {
      &[type='radio'] {
        display: none;
      }
    }
  }
}
.body-rtl {
  @media (max-width: 767px) {
    .tips {
      text-align: right;
      margin-left: unset;
      ul {
        padding-right: 0;
        li {
          + li {
            margin-right: $px10 !important;
            margin-left: unset !important;
          }
        }
      }
    }
  }
}
</style>
